import { render, staticRenderFns } from "./ProfileResult.vue?vue&type=template&id=5bfbd018&scoped=true&"
import script from "./ProfileResult.vue?vue&type=script&lang=js&"
export * from "./ProfileResult.vue?vue&type=script&lang=js&"
import style0 from "./ProfileResult.vue?vue&type=style&index=0&id=5bfbd018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfbd018",
  null
  
)

export default component.exports